import { paths } from 'src/routes/paths';

export const NODE_ENV: string = "production"
export const BASE_URL = 'https://beneficios.expocenternorte.roxcode.io';
export const API_URL = 'https://cn.backend.roxcode.io';
export const ASSETS_API_URL = 'https://i.pravatar.cc/150?img=';
export const VIA_CEP_URL = 'https://viacep.com.br';

export const REDIRECT_URL = 'https://beneficios.scn.roxcode.io/'

export const PATH_AFTER_LOGIN = paths.home.root;

export const PATH_TO_REFRESH_TOKENS = paths.auth.refreshTokens;

export const PATH_TO_REGULATION = 'https://cidadecenternorte.com.br/politica-de-privacidade/';

export const PATH_TO_CONTACT = 'https://api.whatsapp.com/send?phone=5511940759256'
